import { render, staticRenderFns } from "./CustomerProjectCards.vue?vue&type=template&id=5d637fb5&"
import script from "./CustomerProjectCards.vue?vue&type=script&lang=js&"
export * from "./CustomerProjectCards.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProjectCards.vue?vue&type=style&index=0&id=5d637fb5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports